<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <form class="mb-9">
                <div class="row justify-content-between align-items-end g-3 mb-5">
                    <div class="col-12 col-sm-auto col-xl-10">
                    <h2 class="mb-0">Artworks</h2>
                    </div>
                    <div class="col-12 col-sm-auto col-xl-2">
                        <div class="d-flex">
                            <router-link to="/create-artwork" class="btn btn-primary px-5 w-100 text-nowrap">New</router-link>
                        </div>
                    </div>
                </div>
                <div class="row g-5">
                    <div class="col-xl-12">
                        <div class="row gx-3 gy-4">
                            <div class="card" id="table" >
                                <div class="card-header">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <form>
                                                <div class="input-group input-group-flush input-group-merge input-group-reverse">
                                                    <span class="input-group-text search"><MagnifyIcon /></span>
                                                    <input class="form-control list-search" v-model="filtro" type="buscar" placeholder="Search..">
                                                </div>
                                            </form>
                                        </div>
                                    </div> 
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-sm fs--1 mb-0">
                                        <thead>
                                        <tr>
                                            <th class="sort border-top"></th>
                                            <th class="sort border-top">Title</th>
                                            <th class="sort border-top">Description</th>
                                            <th class="sort border-top">State</th>
                                            <th class="sort border-top">Available at</th>
                                            <th class="sort border-top">Prints</th>
                                            <th class="sort border-top">Category</th>
                                            
                                            <th class="sort text-end align-middle pe-0 border-top" scope="col">
                                                <span class="nav-link-icon"><span data-feather="cog"></span></span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody >
                                            <tr v-for="(est,x) in filteredArtworks.reverse()" :key="x">
                                                <td class="align-middle"><img class="rounded" style="width:100px" :src="$url+'/'+est.featured" alt="" /></td>
                                                <td class="align-middle">{{est.title}}<br> <small>slug:{{est.slug }}</small></td>
                                                <td class="align-middle">Año: {{est.year}}<br>{{est.dimensions}}<br>{{est.media_es}}</td>
                                                <td class="align-middle">
                                                    <span v-if="est.is_available == 1" class="badge badge-iasc badge-iasc-success">Available</span>
                                                    <span v-else class="badge badge-iasc badge-iasc-secondary">Sold / Unavailable</span>
                                                
                                                    <span v-if="est.is_private == 1" class="badge badge-iasc badge-iasc-danger">Private</span>
                                                    <span v-else class="badge badge-iasc badge-iasc-success">Public</span>
                                                </td>
                                                <td class="align-middle"><span v-if="est.external_link != '' && est.external_link != 'undefined'">{{est.external_link}}</span><span v-else>{{est.contact_name}}</span></td>
                                                <td class="align-middle">{{(est.has_prints != '' ? 'SI' : 'NO')}} <br> {{est.external_link_print}}</td>
                                                <td class="align-middle">{{(est.category ? est.category : '')}}</td>
                                                
                                                <td class="align-middle white-space-nowrap text-end pe-0">
                                                    <div class="font-sans-serif btn-reveal-trigger position-static">
                                                        <button class="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs--2" type="button" data-bs-toggle="dropdown" data-boundary="window" aria-haspopup="true" aria-expanded="false" data-bs-reference="parent"><svg class="svg-inline--fa fa-ellipsis fs--2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path></svg><!-- <span class="fas fa-ellipsis-h fs--2"></span> Font Awesome fontawesome.com --></button>
                                                        <div class="dropdown-menu dropdown-menu-end py-2">
                                                            <router-link class="dropdown-item" :to="'/artwork/'+est.id">Open</router-link>
                                                            <div class="dropdown-divider"></div>
                                                            <a href="#" class="dropdown-item text-danger" @click="borrar(est)">Delete</a>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                               
                                <div class="d-flex flex-between-center pt-3">
                                    <p class="mb-0 fs--1">
                                        <span class="d-none d-sm-inline-block" data-list-info="data-list-info">showing {{ filteredArtworks.length }} of {{ artworks.length }} </span>
                                        <span class="d-none d-sm-inline-block"> &mdash; </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </form>
        </div>
    </section>
  </template>
  
  <script>
  // @ is an alias to /src
  import SideBar from '@/components/SideBarNav.vue'
  import TopBar from '@/components/TopBarNav.vue'
  import axios from 'axios'
  import MagnifyIcon from 'vue-material-design-icons/Magnify.vue'

  export default {
    name: 'artworksView',
    components:{SideBar,TopBar,MagnifyIcon},
    data(){
        return{
            artworks:[],
            filtro:''
        }
    },
    created(){
        this.getData()
    },
    computed:{
        filteredArtworks(){
            let res = this.artworks.filter((e)=>{
                if(this.filtro != ''){
                    return (e.title) ? e.title.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.subtitle_en) ? e.subtitle_en.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.subtitle_es) ? e.subtitle_es.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.long_description) ? e.long_description.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.author) ? e.author.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.external_link) ? e.external_link.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.date) ? e.date.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.short_description) ? e.short_description.toLowerCase().includes(this.filtro.toLowerCase()) : ''
                }else{
                    return e
                }
            })
            return res
        }
    },
    methods:{
        getData(){
             axios.get(this.$url+'/artworks',{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                this.artworks = res.data
                console.log(this.artworks)
            }).catch((err)=>{
                console.log(err)
            })
        },
        borrar(data){
            axios.post(this.$url+'/artworks/delete/'+data.id,{},{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                this.artworks = this.artworks.filter(e=>e != data.id)
            }).catch((err)=>{
                console.log(err)
            })
        }
    }
  }
  </script>
  
                    